var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var LayoutIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 46,
    glyphHeight: 46
  }), React.createElement("path", {
    d: "M45.9564 0.043457H16.739V4.21737H45.9564V0.043457Z"
  }), React.createElement("path", {
    d: "M45.9564 8.39136H16.739V12.5653H45.9564V8.39136Z"
  }), React.createElement("path", {
    d: "M12.5652 12.5652V0.043457H0.043457V12.5652H12.5652ZM4.21737 4.21737H8.39128V8.39128H4.21737V4.21737Z"
  }), React.createElement("path", {
    d: "M45.9564 16.7391H16.739V20.9131H45.9564V16.7391Z"
  }), React.createElement("path", {
    d: "M45.9564 25.0869H16.739V29.2608H45.9564V25.0869Z"
  }), React.createElement("path", {
    d: "M12.5652 29.2609V16.7391H0.043457V29.2609H12.5652ZM4.21737 20.913H8.39128V25.087H4.21737V20.913Z"
  }), React.createElement("path", {
    d: "M45.9564 33.4348H16.739V37.6087H45.9564V33.4348Z"
  }), React.createElement("path", {
    d: "M45.9564 41.7826H16.739V45.9565H45.9564V41.7826Z"
  }), React.createElement("path", {
    d: "M12.5652 45.9566V33.4348H0.043457V45.9566H12.5652ZM4.21737 37.6087H8.39128V41.7826H4.21737V37.6087Z"
  }));
};
export var LayoutIconGlyph = function (props) {
  return React.createElement(LayoutIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};